import clsx from "clsx/lite"
import { isArray, isString } from "lodash"

export default ({
    filters = [],
    active,
    className = "",
    callback = () => {},
}) => {
    const isActive = (filter) => {
        if (isArray(active)) return active.includes(filter)

        if (isString(active)) return active == filter

        return false
    }

    const computedColClass = `md:columns-${filters.length}`

    return (
        <div
            className={clsx(
                "w-fit mx-auto",
                "columns-2 sm:columns-3",
                computedColClass,
                className,
            )}
        >
            {filters.map((filter, idx) => (
                <div
                    key={`builder-gallery-${idx}`}
                    className="flex cursor-pointer mx-auto w-full"
                    onClick={() => callback(filter)}
                >
                    <span
                        className={clsx(
                            "uppercase text-[#393437] font-bold mx-auto border-t-4 whitespace-nowrap py-2 px-6 m-1 w-full text-center",
                            isActive(filter) ?
                                "bg-garden-grove text-white-snow border-white-snow"
                            :   "hover:border-garden-grove border-white-snow",
                        )}
                    >
                        {filter}
                    </span>
                </div>
            ))}
        </div>
    )
}
